import React from 'react';
import ModalBase from '../ModalBase';

interface ConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    heading: string;
    text: string;
    confirmButtonText?: string;
    onConfirm: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
    isOpen,
    onClose,
    heading,
    text,
    confirmButtonText = 'Confirm',
    onConfirm,
}) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <ModalBase onClose={onClose}>
            <div className="confirmation-modal-content">
                <h2>{heading}</h2>
                <p>{text}</p>
                <div className="button-row">
                    <button className="btn-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="btn-primary" onClick={handleConfirm}>
                        {confirmButtonText}
                    </button>
                </div>
            </div>
        </ModalBase>
    );
};

export default ConfirmModal;
